export default "__VITE_ASSET__B6oHQ5Bl__"